import React from 'react';
import NavigationStepper, {
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import PredefinedPhrasesList from './PredefinedPhrasesList';
import { PhraseType } from '../../../../graphql/graphql';
import PredefinedPhrasesDiscourseSetup from '../PredefinedPhrasesDiscourse/PredefinedPhrasesDiscourseSetup';
import { isAllowed } from '../../../../Services/acl.service';

interface Props {
	onEdit?: () => void;
	type?: PhraseType;
}

const PredefinedPhrasesSetup: React.FC<Props> = ({ onEdit, type }) => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'component.predefinedPhrasesSetup.chat',
			key: PhraseType.Chat,
			component: () => (
				<PredefinedPhrasesList type={PhraseType.Chat} onEdit={onEdit} />
			),
		},
		{
			name: 'component.predefinedPhrasesSetup.discourse',
			key: PhraseType.Discourse,
			component: () => <PredefinedPhrasesDiscourseSetup onEdit={onEdit} />,
		},
	];

	if (isAllowed('laboratory_result_mise')) {
		steps.push({
			name: 'component.predefinedPhrasesSetup.laboratoryResults',
			key: PhraseType.LaboratoryResult,
			component: () => (
				<PredefinedPhrasesList
					type={PhraseType.LaboratoryResult}
					onEdit={onEdit}
				/>
			),
		});
	}

	return (
		<NavigationStepper
			steps={steps}
			showStepNumbers={false}
			canSkip
			initialStepPath={type ?? PhraseType.Chat}
		/>
	);
};

export default PredefinedPhrasesSetup;
